import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class InvoicesToDoneManually {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) { }

  async run(inv_ids): Promise<any> {
    let args = { 
        inv_ids: inv_ids,
    }
    return await this.dispatcher.dispatch('invoices.to.done.manually', args)
  }
}